import api, {handleAPIErrors} from 'shared/api'

const FETCH_REQUEST = 'remunerationPolicies/FETCH_REQUEST'
const FETCH_SUCCESS = 'remunerationPolicies/FETCH_SUCCESS'
const FETCH_FAILURE = 'remunerationPolicies/FETCH_FAILURE'
const FETCH_OPTION_REQUEST = 'remunerationPolicies/FETCH_OPTION_REQUEST'
const FETCH_OPTION_SUCCESS = 'remunerationPolicies/FETCH_OPTION_SUCCESS'
const FETCH_OPTION_FAILURE = 'remunerationPolicies/FETCH_OPTION_FAILURE'
const FETCH_RESULT_REQUEST = 'remunerationPolicies/FETCH_RESULT_REQUEST'
const FETCH_RESULT_SUCCESS = 'remunerationPolicies/FETCH_RESULT_SUCCESS'
const FETCH_RESULT_FAILURE = 'remunerationPolicies/FETCH_RESULT_FAILURE'
const SET_PARAMS = 'remunerationPolicies/SET_PARAMS'

const initialState = {
    result: [],
    options: {
        sectors: [],
        min_market_caps: [],
        max_market_caps: [],
        min_totals: [],
        max_totals: [],
        min_total_assets: [],
        max_total_assets: [],
        min_revenues: [],
        max_revenues: []
    },
    sectorResult: {
        tableData: {},
        chartData: {}
    },
    resultLoading: false,
    resultLoaded: false,
    loading: false,
    loaded: false,
    optionLoading: false,
    optionLoaded: false,
    errors: {},
    analysisParams: {}
}

export function setAnalysisParams(payload) {
    return {
        type: SET_PARAMS,
        payload
    }
}
export function fetchRequest() {
    return {
        type: FETCH_REQUEST,
    }
}

export function fetchSuccess(payload) {
    return {
        type: FETCH_SUCCESS,
        payload,
    }
}

export function fetchFailure(errors) {
    return {
        type: FETCH_FAILURE,
        errors,
    }
}

export function fetchOptionRequest() {
    return {
        type: FETCH_OPTION_REQUEST,
    }
}

export function fetchOptionSuccess(payload) {
    return {
        type: FETCH_OPTION_SUCCESS,
        payload,
    }
}

export function fetchOptionFailure(errors) {
    return {
        type: FETCH_OPTION_FAILURE,
        errors,
    }
}

export function fetchResultRequest() {
    return {
        type: FETCH_RESULT_REQUEST,
    }
}

export function fetchResultSuccess(payload) {
    return {
        type: FETCH_RESULT_SUCCESS,
        payload,
    }
}

export function fetchResultFailure(errors) {
    return {
        type: FETCH_RESULT_FAILURE,
        errors,
    }
}

export function setFilterParams(params) {
    return (dispatch) => {
        dispatch(setAnalysisParams(params))
    }
}

export function searchCompany(options, callback) {
    return (dispatch) => {
        dispatch(fetchRequest())

        return api(`api/v1/remuneration_policies`, options)
            .then(response => response.json().then(json => ({json, response})))
            .then(({json, response}) => {
                if (!response.ok) {
                    return Promise.reject(json)
                }

                dispatch(fetchSuccess(json))

                callback(true)
            })
            .catch((exception) => {
                handleAPIErrors(exception, (errors) => {
                    dispatch(fetchFailure(errors))
                })
                callback(false)
            })
    }
}

export function loadOptions() {
    return (dispatch) => {
        dispatch(fetchOptionRequest())

        return api(`api/v1/remuneration_policies/options`)
            .then(response => response.json().then(json => ({json, response})))
            .then(({json, response}) => {
                if (!response.ok) {
                    return Promise.reject(json)
                }

                dispatch(fetchOptionSuccess(json))
            })
            .catch((exception) => {
                handleAPIErrors(exception, (errors) => {
                    dispatch(fetchOptionFailure(errors))
                })
            })
    }
}

export function downloadData(options = {}, cb = null) {
    const config = {
        method: 'PATCH',
        body: JSON.stringify(options)
    }

    return (dispatch) => {

        return api(`api/v1/remuneration_policies/sector_analysis`, {}, config)
            .then(response => response.json().then(json => ({json, response})))
            .then(({json, response}) => {
                if (!response.ok) {
                    return Promise.reject(json)
                }  
                toastr.success('Downloading enqueued, you should received it shortly')
            })
            .catch((exception) => {
                toastr.error('Something went wrong, please try later')
            })
    }
}

export function updateResult(options = {}, cb = null) {
    const config = {
        method: 'PATCH',
        body: JSON.stringify(options)
    }

    return (dispatch) => {
        dispatch(fetchResultRequest())

        return api(`api/v1/remuneration_policies/sector_analysis`, {}, config)
            .then(response => response.json().then(json => ({json, response})))
            .then(({json, response}) => {
                if (!response.ok) {
                    return Promise.reject(json)
                }

                dispatch(fetchResultSuccess(json))

                if (cb) cb()
            })
            .catch((exception) => {
                handleAPIErrors(exception, (errors) => {
                    dispatch(fetchResultFailure(errors))
                })
            })
    }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
    const {payload, type, errors} = action

    switch (type) {
        case SET_PARAMS:
            return Object.assign({}, state, {
                analysisParams: payload,
            })
        case FETCH_REQUEST:
            return Object.assign({}, state, {
                loading: true
            })
        case FETCH_SUCCESS:
            return Object.assign({}, state, {
                loading: false,
                loaded: true,
                errors: [],
                result: payload
            })
        case FETCH_FAILURE:
            return {
                ...state,
                loading: false,
                loaded: true,
                errors: errors
            }
        case FETCH_OPTION_REQUEST:
            return Object.assign({}, state, {
                optionLoading: true
            })
        case FETCH_OPTION_SUCCESS:
            return Object.assign({}, state, {
                optionLoading: false,
                optionLoaded: true,
                errors: [],
                options: payload
            })
        case FETCH_OPTION_FAILURE:
            return {
                ...state,
                optionLoading: false,
                optionLoaded: true,
                errors: errors
            }
        case FETCH_RESULT_REQUEST:
            return Object.assign({}, state, {
                resultLoading: true
            })
        case FETCH_RESULT_SUCCESS:
            return Object.assign({}, state, {
                resultLoading: false,
                resultLoaded: true,
                errors: [],
                sectorResult: payload
            })
        case FETCH_RESULT_FAILURE:
            return {
                ...state,
                resultLoading: false,
                resultLoaded: true,
                errors: errors
            }
        default:
            return state
    }
}

